import { Copy, Pencil, RotateCcw, X } from "lucide-react";
import { toast } from "sonner";

const btn = "inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-colors disabled:opacity-40 disabled:pointer-events-none";

export async function copierTexte(text) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Texte copié dans le presse-papiers");
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text; document.body.appendChild(ta); ta.select();
    const ok = document.execCommand("copy"); ta.remove();
    ok ? toast.success("Texte copié dans le presse-papiers") : toast.error("Copie impossible");
  }
}

export function MessageTools({ text, onEdit, onResend, disabled, testId }) {
  return (
    <div className="mt-1 flex justify-end gap-1" data-testid={`${testId}-tools`}>
      <button type="button" className={btn} onClick={() => copierTexte(text)} data-testid={`${testId}-copy`} title="Copier">
        <Copy className="h-3 w-3" />Copier</button>
      <button type="button" className={btn} onClick={onEdit} disabled={disabled} data-testid={`${testId}-edit`} title="Modifier">
        <Pencil className="h-3 w-3" />Modifier</button>
      <button type="button" className={btn} onClick={onResend} disabled={disabled} data-testid={`${testId}-resend`} title="Renvoyer">
        <RotateCcw className="h-3 w-3" />Renvoyer</button>
    </div>
  );
}

export function EditBanner({ onCancel, testId }) {
  return (
    <div className="mx-4 mt-3 flex items-center justify-between rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid={`${testId}-edit-banner`}>
      <span>Modification du message : corrigez le texte puis renvoyez. Les réponses suivantes seront remplacées ; les actions déjà exécutées ne seront pas refaites.</span>
      <button type="button" onClick={onCancel} className="ml-3 inline-flex items-center gap-1 font-semibold hover:underline" data-testid={`${testId}-edit-cancel`}>
        <X className="h-3 w-3" />Annuler</button>
    </div>
  );
}
